<template>

  <el-dialog title="发货" v-if="visible" :visible.sync="visible" width="450px" :before-close="handleClose">

    <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="80px"
    >
      <el-form-item label="快递单号" prop="deliverNo" >
        <el-input
            clearable
            v-model="ruleForm.deliverNo"
            placeholder="请输入快递单号"
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button class="sub-button" type="primary" @click="submitForm">确 定</el-button>
    </span>
  </el-dialog>

</template>

<script>

export default {
  name: "delivery",
  data(){
    return {
      visible: false,
      tradeNo: '',
      ruleForm: {
        deliverNo: undefined
      },
      rules: {
        deliverNo: [{ required: true, message: "请输入快递单号", trigger: "blur" }]
      },
    }
  },
  methods:{
    submitForm() {
      this.$refs.ruleForm.validate(async value => {
        if (value) {
          this.$http.post(this.$api.customerEnterprise.deliver, {tradeNo: this.tradeNo , deliverNo: this.ruleForm.deliverNo}).then(res => {
            if (res.data.code == 200){
              this.$message.success('操作成功')
              this.handleClose();
            }
          })
        }
      });
    },
    show(visible , tradeNo) {
      this.visible = visible
      this.tradeNo = tradeNo

    },
    handleClose() {
      this.visible = false;
      this.ruleForm.deliverNo = undefined
      this.tradeNo = undefined
      this.$emit('handleQuery')
    }
  }
}
</script>

<style scoped lang="less">
::v-deep .el-dialog__body {
  padding: 20px 30px 0;
}
</style>
